module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-2-86c8a9608516467663d973d953b8144e.jpg";